module.exports = {"330382001":"城东街道","330382002":"乐成街道","330382003":"城南街道","330382004":"盐盆街道","330382005":"翁垟街道","330382006":"白石街道","330382007":"石帆街道","330382008":"天成街道","330382101":"大荆镇","330382102":"仙溪镇","330382104":"雁荡镇","330382105":"芙蓉镇","330382106":"清江镇","330382108":"虹桥镇","330382111":"淡溪镇","330382114":"柳市镇","330382115":"北白象镇","330382121":"湖雾镇","330382122":"南塘镇","330382123":"南岳镇","330382124":"蒲岐镇","330382125":"磐石镇","330382210":"智仁乡","330382211":"龙西乡","330382212":"岭底乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330382.json
// module id = 899
// module chunks = 0